import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-pb-4 tw-space-y-6" };
const _hoisted_2 = { class: "tw-space-y-3" };
const _hoisted_3 = { class: "tw-flex tw-gap-3 tw-items-center tw-w-full" };
import Scrollbar from 'simplebar-vue';
import { useRoute, RouterLink } from 'vue-router';
import { useLogo } from '@/hooks/useLogo';
import { useCatSidebar } from '@/stores/catSidebar';
import { Avatar, AvatarFallback, AvatarImage, } from '@/components/ui/avatar/index';
const __default__ = {
    name: 'CasinoComponent',
    props: {
        liveGameCategories: {
            type: Array,
            required: true,
        },
        selectedCategory: {
            type: Object,
            required: false,
            default: null,
        },
    },
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    emits: ['close-sidebar', 'category-changed'],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const logo = useLogo();
        const catsidebar = useCatSidebar();
        const emit = __emit;
        const handleItemClick = () => {
            catsidebar.toggleSidebar();
            emit('close-sidebar');
            emit('category-changed');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Scrollbar), null, {
                default: _withCtx(() => [
                    _createElementVNode("nav", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.liveGameCategories, (gameCat) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: gameCat.key,
                                        class: _normalizeClass([
                                            'tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-group tw-border-l-transparent hover:tw-font-medium hover:tw-border-l-[#32d97b] hover:tw-text-[#32d97b] hover:tw-bg-hover',
                                            __props.selectedCategory && __props.selectedCategory.key === gameCat.key
                                                ? 'tw-font-medium tw-border-l-[#32d97b] tw-text-[#32d97b] tw-bg-hover'
                                                : 'tw-text-[#738499]',
                                        ])
                                    }, [
                                        _createVNode(_unref(RouterLink), {
                                            to: gameCat.key,
                                            class: "tw-flex tw-justify-between tw-p-4 tw-text-[13px] tw-font-medium tw-truncate tw-items-center",
                                            onClick: handleItemClick
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createVNode(_unref(Avatar), {
                                                        shape: "square",
                                                        size: "base",
                                                        class: "tw-max-h-[30px] tw-w-[30px] tw-bg-transparent"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(AvatarImage), {
                                                                class: "!tw-object-contain",
                                                                src: `${gameCat.logoURL}`,
                                                                alt: "game"
                                                            }, null, 8, ["src"]),
                                                            _createVNode(_unref(AvatarFallback), { class: "tw-text-[12px] tw-font-semibold" }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(gameCat.name.charAt(0).toUpperCase()), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createElementVNode("p", {
                                                        class: _normalizeClass([
                                                            'tw-group tw-w-full tw-text-[13px] tw-font-medium tw-relative tw-truncate',
                                                            __props.selectedCategory && __props.selectedCategory.key === gameCat.key
                                                                ? 'tw-text-[#32d97b]'
                                                                : '',
                                                            'group-hover:tw-text-[#32d97b]',
                                                        ])
                                                    }, _toDisplayString(gameCat?.name), 3),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass([
                                                            'tw-text-right tw-text-[13px]',
                                                            __props.selectedCategory && __props.selectedCategory.key === gameCat.key
                                                                ? 'tw-text-[#32d97b]'
                                                                : '',
                                                            'group-hover:tw-text-[#32d97b]',
                                                        ])
                                                    }, _toDisplayString(gameCat?.totalGames), 3)
                                                ])
                                            ]),
                                            _: 2
                                        }, 1032, ["to"])
                                    ], 2));
                                }), 128))
                            ])
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
